"use client";

import { RichtextRenderer } from "@/components/atoms/rich-text-render";import { HomeBrandsTopListDatasourcesCrmTopListDatasource } from "@/types/generated";
import "../hotel-details/meeting-room/meeting-icomoon-bundle.css";
interface BrandTopListProps {
  brandTopList: HomeBrandsTopListDatasourcesCrmTopListDatasource;
}
/**
 * Component: BrandkamenoiHotel
 * Description: Displays brand-specific information such as title and description for the Kamenoi Hotel section.
 * It includes styled content using inline CSS and renders formatted text via RichtextRenderer.
 */
export const BrandkamenoiHotel = ({ brandTopList }: BrandTopListProps) => {
  return (
    <div className="mx-auto w-full max-w-[980px] px-4 py-12 lg:px-0 lg:py-20">
      <style>
        {`
          .btn-brand-lp {
            border-radius: 5px;
            background-color: var(--fill-base-main);
            color: #fff !important;
            font-size: 16px;
            font-weight: 700;
            font-family: Meiryo;
            height: auto; 
            line-height: 1.2;
            padding: 15px;
            position: relative;
            display: inline-block;
            margin: 0 auto 20px;
            width: 100%;
            max-width: 180px;
          }
          .btn-brand-lp:hover{
            text-decoration: none !important;
            opacity: .75;
            transition: all .3s ease;
          }
          .btn-brand-lp span{
            font-size:15px;
            position:static;
            padding-left:16px;
            transform: translateY(-50%);
          }
        `}
      </style>

      {/* Header section with rich text rendering for dynamic title */}
      <h2 className="mb-10 text-center text-[28px]">
        <span className="inline-block border-b border-gray-200 px-[5px] pb-[15px]">
          <RichtextRenderer content={brandTopList?.header_title as string} />
        </span>

        {/* Description section with rich text rendering and custom icon styling */}
      </h2>
      <div className="meeting-room-icomoon text-center">
        <RichtextRenderer content={brandTopList?.description as string} />
      </div>
    </div>
  );
};
